import { useState } from 'react'

import { BlockComponentsRole75Checker, ReactSelect as Select } from 'components'
import { useDebounce } from 'hooks'
import { useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'
import { TOLGEE_GLOBALS } from 'utils'

import './index.scss'
import CustomOption from './components/CustomOption'

interface ISearchWithRecommendations {
  onType: (value: unknown, callback: (...args: any) => void) => void
  handleOnChange: (value: unknown) => void
  placeholder: string
  CustomGroupHeadingLabel?: JSX.Element
  onSubmit?: (value: string) => void
  value?: { label: string }
  isCustomOption?: boolean
  isDisabled?: boolean
  isViewerBlocked?: boolean
  defaultSearchText?: string
}

export default function SearchWithRecommendations({
  onType,
  handleOnChange,
  placeholder,
  CustomGroupHeadingLabel,
  onSubmit,
  value,
  isCustomOption,
  isDisabled,
  isViewerBlocked = true,
  defaultSearchText = '',
}: ISearchWithRecommendations) {
  const [searchText, setSearchText] = useState(value?.label || defaultSearchText)
  const [lastOptions, setLastOptions] = useState([])
  const t = useTranslate()

  const isUserViewer = isViewerBlocked && UserStore.getRole === 'viewer'

  const { debouncedAction: debouncedOnType } = useDebounce(onType, 500)

  const handleType = (value, callback) => {
    debouncedOnType(value, options => {
      setLastOptions(options ?? [])
      callback(options)
    })
  }

  const keyDownHandler = e => {
    const key = e?.key

    if (key === 'Enter') {
      e.preventDefault()
      onSubmit?.(searchText)
    }
  }

  const handleChange = (value, { action }) => {
    if (action === 'input-change') {
      setSearchText(value)
    }
  }

  return (
    <div className="SearchWithRecommendations">
      <BlockComponentsRole75Checker isClickBlocked={isUserViewer} blockMessage={t(TOLGEE_GLOBALS.viewerBlockMessage)}>
        <Select
          key="topics"
          containerClass="SearchWithRecommendations-container"
          className="SearchWithRecommendations-select"
          asyncSelect
          name="search-with-recommendations"
          onChange={handleOnChange}
          inputValue={searchText}
          placeholder={placeholder}
          onInputChange={handleChange}
          onKeyDown={keyDownHandler}
          value={value}
          loadOptions={handleType}
          defaultOptions={searchText ? lastOptions : []}
          openMenuOnClick={lastOptions.length > 0}
          tabSelectsValue={false}
          noOptionsMessage={({ inputValue }) => {
            return !inputValue ? null : t(TOLGEE_GLOBALS.noResultsFound)
          }}
          isDisabled={isDisabled}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
            ...(Boolean(CustomGroupHeadingLabel) && { GroupHeading: CustomGroupHeadingLabel }),
            ...(isCustomOption && { Option: CustomOption }),
          }}
        />
      </BlockComponentsRole75Checker>
    </div>
  )
}
